// スクロール位置の自動復元を無効化してページ先頭から表示する
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}
window.scrollTo(0, 0);

(() => {
  const SELECTORS = {
    root: '[data-barefoot-lp]',
    intro: '[data-barefoot-intro]',
    introHero: '[data-barefoot-intro-hero]',
    spIntro: '[data-barefoot-sp-intro]',
    spIntroHero: '[data-barefoot-sp-intro-hero]',
    pcHeroVideo: '.l-barefoot--pc [data-hero-video]',
    spHeroVideo: '.l-barefoot--sp [data-hero-video]',
    heroPlayButton: '[data-hero-play-button]',
    pcSoundButton: '.l-barefoot--pc [data-hero-sound-button]',
    spSoundButton: '.l-barefoot--sp [data-hero-sound-button]',
    pcGrid: '.l-barefoot--pc .l-barefoot__grid',
    hero: '.p-hero',
    heroMovie: '.p-hero__movie',
    resizableMedia: 'img, picture, video',
    introAside: '.p-barefoot-intro__aside',
    introSideProduct: '.p-barefoot-intro__side-product',
    introSideProductImage: '.p-barefoot-intro__side-product-image',
    sideProductPicture: '.p-side-product__picture',
    sideProductSlider: '[data-side-product-slider]',
    sideProductSlide: '[data-side-product-slide]',
    spProductSlider: '[data-sp-product-slider]',
    spProductSlide: '[data-sp-product-slide]',
    spProduct: '[data-sp-product]',
    spIntroProductPicture: '.p-barefoot-sp-intro__thumb--product .p-barefoot-sp-intro__picture',
    spIntroLastThumb: '.p-barefoot-sp-intro__thumb--right',
    spHeroMovie: '.l-barefoot--sp .p-hero__movie',
  };

  const CLASS_NAMES = {
    introReady: 'is-intro-ready',
    introPlaying: 'is-intro-playing',
    introEnding: 'is-intro-ending',
    introEnded: 'is-intro-ended',
    active: 'is-active',
    soundOn: 'is-sound-on',
    heroPlayRequired: 'is-hero-play-required',
  };

  const INTRO_ANIMATION_NAME = 'barefootIntroHeroGrow';
  const INTRO_FALLBACK_DURATION = 6000;
  const INTRO_END_FADE_DURATION = 1200;
  const INTRO_ASSET_WAIT_LIMIT = 1200;
  const SP_INTRO_HERO_GROW_DELAY = 2770;
  const SP_INTRO_HERO_GROW_DURATION = 2300;
  const SP_INTRO_HERO_SWITCH_PROGRESS = 0.9;
  const SP_INTRO_SWITCH_START_DELAY =
    SP_INTRO_HERO_GROW_DELAY + (SP_INTRO_HERO_GROW_DURATION * SP_INTRO_HERO_SWITCH_PROGRESS);
  const SIDE_PRODUCT_SLIDE_INTERVAL = 4500;
  const PC_MEDIA_QUERY = '(min-width: 1024px)';

  const root = document.querySelector(SELECTORS.root);

  if (!root) return;

  const intro = root.querySelector(SELECTORS.intro);
  const introHero = root.querySelector(SELECTORS.introHero);
  const spIntro = root.querySelector(SELECTORS.spIntro);
  const spIntroHero = root.querySelector(SELECTORS.spIntroHero);
  const spIntroLastThumb = root.querySelector(SELECTORS.spIntroLastThumb);
  const heroVideo = root.querySelector(SELECTORS.pcHeroVideo);
  const spHeroVideo = root.querySelector(SELECTORS.spHeroVideo);
  const pcMediaQuery = window.matchMedia(PC_MEDIA_QUERY);

  let isIntroFinished = false;
  let introFallbackTimer = null;
  let startSideProductSlider = () => {};
  let startSpProductSlider = () => {};
  let isIntroScrollLocked = false;
  let introScrollY = 0;
  let previousHtmlOverflowY = '';
  let previousBodyOverscrollBehavior = '';
  let isRestoringIntroScroll = false;

  const INTRO_SCROLL_LOCK_EVENT_OPTIONS = { passive: false };
  const INTRO_SCROLL_LOCK_KEYS = new Set([
    ' ',
    'ArrowDown',
    'ArrowUp',
    'End',
    'Home',
    'PageDown',
    'PageUp',
  ]);

  const setVideoPreload = () => {
    if (pcMediaQuery.matches) {
      if (spHeroVideo) spHeroVideo.preload = 'none';
      if (heroVideo) heroVideo.preload = 'auto';
    } else {
      if (heroVideo) heroVideo.preload = 'none';
      if (spHeroVideo) spHeroVideo.preload = 'auto';
    }
  };

  const setGridColumnWidth = () => {
    const grid = root.querySelector(SELECTORS.pcGrid);

    if (!grid) return;

    const columnCount = Number.parseInt(
      getComputedStyle(root).getPropertyValue('--barefoot-main-column-count'),
      10
    ) || 8;

    const gridWidth = grid.getBoundingClientRect().width;
    const columnWidth = gridWidth / columnCount;

    if (columnWidth > 0) {
      root.style.setProperty('--barefoot-grid-column-width', `${columnWidth}px`);
    }
  };

  const setHeroHeight = () => {
    const hero = root.querySelector(SELECTORS.hero);
    const heroMovie = root.querySelector(SELECTORS.heroMovie);
    const target = heroMovie || hero;

    if (!target) return;

    const height = target.getBoundingClientRect().height;
    const fallbackHeight = window.innerHeight * 0.75;
    const heroHeight = height > 50 ? Math.min(height, fallbackHeight) : fallbackHeight;

    root.style.setProperty('--barefoot-hero-height', `${heroHeight}px`);
    root.style.setProperty('--barefoot-intro-hero-height', `${heroHeight}px`);
  };

  const setSpIntroPicture = () => {
    // <picture> は display:inline のため、<img> を直接計測する
    const spProductImage = root.querySelector('.l-barefoot--sp .p-sp-product__image');
    if (!spProductImage) return;

    const rect = spProductImage.getBoundingClientRect();

    // width・height どちらかが 0 の場合はスキップ（画像未ロードなど）
    if (rect.width === 0 || rect.height === 0) return;

    root.style.setProperty('--sp-intro-product-w', `${rect.width}px`);
    root.style.setProperty('--sp-intro-product-h', `${rect.height}px`);
    root.style.setProperty('--sp-intro-product-top', `${rect.top}px`);
    root.style.setProperty('--sp-intro-product-left', `${rect.left}px`);
  };

  const setSpProductHeight = () => {
    const spProduct = root.querySelector(SELECTORS.spProduct);

    if (!spProduct) return;

    const height = spProduct.getBoundingClientRect().height;

    if (height > 0) {
      root.style.setProperty('--barefoot-p-sp-product-height', `${height}px`);
    }
  };

  const setSpIntroProductImageHeight = () => {
    const picture = root.querySelector(SELECTORS.spIntroProductPicture);

    if (!picture) return;

    const height = picture.getBoundingClientRect().height;

    if (height > 0) {
      root.style.setProperty('--barefoot-p-sp-intro-product-image-height', `${height}px`);
    }
  };

  const setSpIntroHeroBounds = () => {
    if (
      root.classList.contains(CLASS_NAMES.introPlaying) ||
      root.classList.contains(CLASS_NAMES.introEnding)
    ) return;

    const introHeroThumb = root.querySelector(SELECTORS.spIntroLastThumb);
    const heroMovie = root.querySelector(SELECTORS.spHeroMovie);

    if (!introHeroThumb || !heroMovie) return;

    const fromRect = introHeroThumb.getBoundingClientRect();
    const toRect = heroMovie.getBoundingClientRect();

    if (
      fromRect.width === 0 ||
      fromRect.height === 0 ||
      toRect.width === 0 ||
      toRect.height === 0
    ) return;

    root.style.setProperty('--sp-intro-hero-from-top', `${fromRect.top}px`);
    root.style.setProperty('--sp-intro-hero-from-left', `${fromRect.left}px`);
    root.style.setProperty('--sp-intro-hero-from-width', `${fromRect.width}px`);
    root.style.setProperty('--sp-intro-hero-from-height', `${fromRect.height}px`);
    root.style.setProperty('--sp-intro-hero-to-top', `${toRect.top}px`);
    root.style.setProperty('--sp-intro-hero-to-left', `${toRect.left}px`);
    root.style.setProperty('--sp-intro-hero-to-width', `${toRect.width}px`);
    root.style.setProperty('--sp-intro-hero-to-height', `${toRect.height}px`);
  };

  const setIntroProductImageSize = () => {
    const introAside = root.querySelector(SELECTORS.introAside);
    const introSideProduct = root.querySelector(SELECTORS.introSideProduct);
    const sideProductPicture = root.querySelector(SELECTORS.sideProductPicture);
    const fallbackImage = root.querySelector(SELECTORS.introSideProductImage);

    if (!introAside || !introSideProduct || !sideProductPicture) return;

    const asideRect = introAside.getBoundingClientRect();
    const pictureRect = sideProductPicture.getBoundingClientRect();
    const fallbackRect = fallbackImage?.getBoundingClientRect();
    const width = pictureRect.width || fallbackRect?.width || 0;
    const height = pictureRect.height || fallbackRect?.height || 0;

    if (width > 0) {
      root.style.setProperty('--barefoot-intro-product-image-width', `${width}px`);
    }

    if (height > 0) {
      root.style.setProperty('--barefoot-intro-product-image-height', `${height}px`);
    }

    if (pictureRect.width > 0 && pictureRect.height > 0) {
      root.style.setProperty('--barefoot-intro-side-product-left', `${pictureRect.left - asideRect.left}px`);
      root.style.setProperty('--barefoot-intro-side-product-top', `${pictureRect.top - asideRect.top}px`);
    }
  };

  const updateLayoutVariables = () => {
    setGridColumnWidth();
    setHeroHeight();
    setIntroProductImageSize();
    setSpIntroPicture();
    setSpProductHeight();
    setSpIntroProductImageHeight();
    setSpIntroHeroBounds();
  };

  const wait = (duration) => new Promise((resolve) => {
    window.setTimeout(resolve, duration);
  });

  const waitForIntroAssets = async () => {
    if (!intro) return;

    const images = Array.from(intro.querySelectorAll('img'));

    const decodePromises = images.map((image) => {
      if (image.complete && image.naturalWidth > 0) return Promise.resolve();

      if (typeof image.decode === 'function') {
        return image.decode().catch(() => undefined);
      }

      return new Promise((resolve) => {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', resolve, { once: true });
      });
    });

    await Promise.race([
      Promise.all(decodePromises),
      wait(INTRO_ASSET_WAIT_LIMIT),
    ]);
  };

  const setHeroPlayButtonVisible = (video, isVisible) => {
    if (!video) return;

    const movie = video.closest(SELECTORS.heroMovie);
    const button = movie?.querySelector(SELECTORS.heroPlayButton);

    if (!movie || !button) return;

    movie.classList.toggle(CLASS_NAMES.heroPlayRequired, isVisible);
    button.hidden = !isVisible;
  };

  const playVideo = (video, options = {}) => {
    if (!video) return;

    const { resetTime = true } = options;

    if (resetTime) {
      try {
        video.currentTime = 0;
      } catch (error) {
        // Safari/iOSなどで currentTime セットに失敗してもLP表示は継続する
      }
    }

    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise
        .then(() => {
          setHeroPlayButtonVisible(video, false);
        })
        .catch(() => {
          setHeroPlayButtonVisible(video, true);
        });
    } else {
      setHeroPlayButtonVisible(video, false);
    }
  };

  const playHeroVideo = () => {
    playVideo(heroVideo);
    playVideo(spHeroVideo);
  };

  const setupHeroPlayButtons = () => {
    const buttons = root.querySelectorAll(SELECTORS.heroPlayButton);

    buttons.forEach((button) => {
      const movie = button.closest(SELECTORS.heroMovie);
      const video = movie?.querySelector('[data-hero-video]');

      if (!video) return;

      button.addEventListener('click', () => {
        playVideo(video, { resetTime: false });
      });

      video.addEventListener('playing', () => {
        setHeroPlayButtonVisible(video, false);
      });
    });
  };

  const preventIntroScroll = (event) => {
    if (!isIntroScrollLocked) return;

    event.preventDefault();
  };

  const preventIntroKeyScroll = (event) => {
    if (!isIntroScrollLocked || !INTRO_SCROLL_LOCK_KEYS.has(event.key)) return;

    const activeElement = document.activeElement;
    const isEditable = activeElement?.matches?.('input, textarea, select, [contenteditable="true"]');

    if (!isEditable) {
      event.preventDefault();
    }
  };

  const restoreIntroScrollPosition = () => {
    if (!isIntroScrollLocked || isRestoringIntroScroll || window.scrollY === introScrollY) return;

    isRestoringIntroScroll = true;
    window.requestAnimationFrame(() => {
      window.scrollTo(0, introScrollY);
      isRestoringIntroScroll = false;
    });
  };

  const lockIntroScroll = () => {
    if (isIntroScrollLocked) return;

    introScrollY = window.scrollY;
    previousHtmlOverflowY = document.documentElement.style.overflowY;
    previousBodyOverscrollBehavior = document.body.style.overscrollBehavior;
    isIntroScrollLocked = true;

    document.documentElement.style.overflowY = 'scroll';
    document.body.style.overscrollBehavior = 'none';

    window.addEventListener('wheel', preventIntroScroll, INTRO_SCROLL_LOCK_EVENT_OPTIONS);
    window.addEventListener('touchmove', preventIntroScroll, INTRO_SCROLL_LOCK_EVENT_OPTIONS);
    window.addEventListener('keydown', preventIntroKeyScroll);
    window.addEventListener('scroll', restoreIntroScrollPosition);
  };

  const unlockIntroScroll = () => {
    if (!isIntroScrollLocked) return;

    isIntroScrollLocked = false;
    document.documentElement.style.overflowY = previousHtmlOverflowY;
    document.body.style.overscrollBehavior = previousBodyOverscrollBehavior;

    window.removeEventListener('wheel', preventIntroScroll, INTRO_SCROLL_LOCK_EVENT_OPTIONS);
    window.removeEventListener('touchmove', preventIntroScroll, INTRO_SCROLL_LOCK_EVENT_OPTIONS);
    window.removeEventListener('keydown', preventIntroKeyScroll);
    window.removeEventListener('scroll', restoreIntroScrollPosition);
  };

  const finishIntro = () => {
    if (isIntroFinished) return;

    isIntroFinished = true;

    if (introFallbackTimer) {
      window.clearTimeout(introFallbackTimer);
    }

    root.classList.remove(CLASS_NAMES.introReady);
    root.classList.add(CLASS_NAMES.introEnding);

    updateLayoutVariables();
    playHeroVideo();
    startSideProductSlider();
    startSpProductSlider();

    window.setTimeout(() => {
      root.classList.remove(CLASS_NAMES.introPlaying);
      root.classList.remove(CLASS_NAMES.introEnding);
      root.classList.add(CLASS_NAMES.introEnded);

      unlockIntroScroll();

      if (intro) {
        intro.setAttribute('hidden', '');
      }

      if (spIntro) {
        spIntro.setAttribute('hidden', '');
      }
    }, INTRO_END_FADE_DURATION);
  };

  const skipIntro = () => {
    unlockIntroScroll();

    root.classList.remove(CLASS_NAMES.introReady);
    root.classList.remove(CLASS_NAMES.introPlaying);
    root.classList.remove(CLASS_NAMES.introEnding);
    root.classList.add(CLASS_NAMES.introEnded);

    if (intro) {
      intro.setAttribute('hidden', '');
    }

    if (spIntro) {
      spIntro.setAttribute('hidden', '');
    }

    playHeroVideo();
    startSideProductSlider();
    startSpProductSlider();
  };

  const waitForSpIntroAssets = async () => {
    if (!spIntro) return;

    const introImages = Array.from(spIntro.querySelectorAll('img'));

    // SP本編の商品画像もロード待ち（setSpIntroPicture() の計測精度のため）
    const spProductImage = root.querySelector('.l-barefoot--sp .p-sp-product__image');
    const images = spProductImage ? [...introImages, spProductImage] : introImages;

    const decodePromises = images.map((image) => {
      if (image.complete && image.naturalWidth > 0) return Promise.resolve();

      if (typeof image.decode === 'function') {
        return image.decode().catch(() => undefined);
      }

      return new Promise((resolve) => {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', resolve, { once: true });
      });
    });

    await Promise.race([
      Promise.all(decodePromises),
      wait(INTRO_ASSET_WAIT_LIMIT),
    ]);
  };

  const startIntro = async () => {
    updateLayoutVariables();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      skipIntro();
      return;
    }

    if (pcMediaQuery.matches) {
      // PC イントロ
      if (!intro) {
        skipIntro();
        return;
      }

      await waitForIntroAssets();
      updateLayoutVariables();

      lockIntroScroll();

      root.classList.add(CLASS_NAMES.introPlaying);

      if (introHero) {
        introHero.addEventListener('animationend', (event) => {
          if (event.animationName !== INTRO_ANIMATION_NAME) return;
          finishIntro();
        }, { once: true });
      }

      introFallbackTimer = window.setTimeout(finishIntro, INTRO_FALLBACK_DURATION);

    } else {
      // SP イントロ
      if (!spIntro) {
        skipIntro();
        return;
      }

      await waitForSpIntroAssets();
      updateLayoutVariables();

      lockIntroScroll();

      root.classList.add(CLASS_NAMES.introPlaying);

      introFallbackTimer = window.setTimeout(finishIntro, SP_INTRO_SWITCH_START_DELAY);
    }
  };

  const setupSoundButton = () => {
    const bindSoundButton = (video, button) => {
      if (!video || !button) return;

      const updateButton = () => {
        const isMuted = video.muted;
        button.classList.toggle(CLASS_NAMES.soundOn, !isMuted);
        button.setAttribute('aria-label', isMuted ? 'Turn sound on' : 'Turn sound off');
      };

      button.addEventListener('click', () => {
        video.muted = !video.muted;

        if (!video.muted) {
          const playPromise = video.play();

          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {
              video.muted = true;
              updateButton();
            });
          }
        }

        updateButton();
      });

      updateButton();
    };

    bindSoundButton(heroVideo, root.querySelector(SELECTORS.pcSoundButton));
    bindSoundButton(spHeroVideo, root.querySelector(SELECTORS.spSoundButton));
  };

  const setupProductSlider = (sliderSelector, slideSelector) => {
    const slider = root.querySelector(sliderSelector);

    if (!slider) return;

    const slides = Array.from(slider.querySelectorAll(slideSelector));

    if (slides.length <= 1) return;

    let activeIndex = 0;
    let intervalId = null;

    const showSlide = (index) => {
      activeIndex = index;

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle(CLASS_NAMES.active, slideIndex === activeIndex);
      });
    };

    showSlide(0);

    return () => {
      if (intervalId) return;

      showSlide(0);

      intervalId = window.setInterval(() => {
        showSlide((activeIndex + 1) % slides.length);
      }, SIDE_PRODUCT_SLIDE_INTERVAL);
    };
  };

  const setupResizeHandler = () => {
    let animationFrameId = 0;

    const requestUpdate = () => {
      if (animationFrameId) {
        window.cancelAnimationFrame(animationFrameId);
      }

      animationFrameId = window.requestAnimationFrame(updateLayoutVariables);
    };

    window.addEventListener('resize', requestUpdate);
    window.addEventListener('orientationchange', requestUpdate);

    if (typeof ResizeObserver === 'function') {
      const resizeObserver = new ResizeObserver(requestUpdate);
      const resizeTargets = [
        root.querySelector(SELECTORS.pcGrid),
        root.querySelector(SELECTORS.hero),
        root.querySelector(SELECTORS.heroMovie),
        root.querySelector(SELECTORS.spProduct),
        ...root.querySelectorAll(SELECTORS.resizableMedia),
      ].filter(Boolean);

      resizeTargets.forEach((target) => {
        resizeObserver.observe(target);
      });
    }

    if (heroVideo) {
      heroVideo.addEventListener('loadedmetadata', requestUpdate);
      heroVideo.addEventListener('loadeddata', requestUpdate);
    }
  };

  setVideoPreload();
  pcMediaQuery.addEventListener('change', setVideoPreload);

  setupHeroPlayButtons();
  setupSoundButton();
  startSideProductSlider = setupProductSlider(
    SELECTORS.sideProductSlider,
    SELECTORS.sideProductSlide
  ) || (() => {});
  startSpProductSlider = setupProductSlider(
    SELECTORS.spProductSlider,
    SELECTORS.spProductSlide
  ) || (() => {});
  setupResizeHandler();

  window.addEventListener('load', updateLayoutVariables);
  updateLayoutVariables();

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(startIntro);
  });
})();

/* SP スティッキーバー */
(() => {
  const SP_MEDIA_QUERY = '(max-width: 1023px)';

  const root = document.querySelector('[data-barefoot-lp]');
  if (!root) return;

  const productSection = root.querySelector('[data-sp-product]');
  const bar = root.querySelector('[data-sp-product-bar]');
  const topTriggers = root.querySelectorAll('[data-sp-product-bar-top]');

  if (!productSection || !bar) return;

  // IntersectionObserver: p-sp-productが画面外に出たらバーを表示
  const observer = new IntersectionObserver(
    ([entry]) => {
      const isHidden = !entry.isIntersecting;
      bar.classList.toggle('is-visible', isHidden);
      bar.setAttribute('aria-hidden', String(!isHidden));
    },
    { threshold: 0 }
  );

  // SP時のみ監視
  const spMediaQuery = window.matchMedia(SP_MEDIA_QUERY);

  const startObserve = () => {
    if (spMediaQuery.matches) {
      observer.observe(productSection);
    } else {
      observer.unobserve(productSection);
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    }
  };

  startObserve();
  spMediaQuery.addEventListener('change', startObserve);

  const scrollToProductSection = () => {
    if (productSection.getClientRects().length > 0) {
      productSection.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // 商品バーの各トリガー: p-sp-productへスクロール
  topTriggers.forEach((trigger) => {
    trigger.addEventListener('click', scrollToProductSection);
    trigger.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      scrollToProductSection();
    });
  });
})();

/* 動画モーダル */
(() => {
  const root = document.querySelector('[data-barefoot-lp]');

  if (!root) return;

  const setupMovieModal = () => {
    const modal = root.querySelector('[data-movie-modal]');
    const openButtons = root.querySelectorAll('[data-movie-modal-open]');

    if (!modal || !openButtons.length) return;

    const modalVideo = modal.querySelector('video');
    const pageVideos = Array.from(root.querySelectorAll('[data-hero-video]'));
    const closeButtons = modal.querySelectorAll('[data-movie-modal-close]');
    let scrollY = 0;
    let pausedStates = [];

    const openModal = () => {
      scrollY = window.scrollY;
      modal.hidden = false;
      document.body.classList.add('is-movie-modal-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.width = '100%';

      pausedStates = pageVideos.map((v) => {
        const wasPaused = v.paused;
        v.pause();
        return wasPaused;
      });

      if (modalVideo) {
        modalVideo.currentTime = 0;
        modalVideo.play().catch(() => undefined);
      }
    };

    const closeModal = () => {
      modal.hidden = true;
      document.body.classList.remove('is-movie-modal-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);

      if (modalVideo) {
        modalVideo.pause();
        modalVideo.currentTime = 0;
      }

      pageVideos.forEach((v, i) => {
        if (!pausedStates[i]) v.play().catch(() => undefined);
      });
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', openModal);
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModal();
    });
  };

  setupMovieModal();
})();
